"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var SAVE_HOURS = 'Keur Goed';
var NOT_ALLOWED_WARNING = 'Het is niet toegestaan om deze actie uit te voeren.';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        return _super.call(this, props) || this;
    }
    Button.prototype.render = function () {
        var _this = this;
        var buttonClasses = (0, classnames_1.default)('button', { 'button-disabled': this.props.disabled });
        return (React.createElement("span", { className: buttonClasses, title: this.props.disabled ? NOT_ALLOWED_WARNING : '', onClick: function (event) { return _this.props.onClick(); } }, this.props.text));
    };
    return Button;
}(React.Component));
exports.default = Button;
